/* === BASE === */
const zoneBase = {
	fill: "#cccccc",
	fillOpacity: 0.7,
	outlineColor: "#777777",
	outlineWidth: 1,
	outlineOpacity: 1
};

const zoneBaseSmall = {
	...zoneBase, outlineOpacity: .3
}

const zoneTransparent = {
	...zoneBase, fill: null, outlineWidth: 2
}

const zoneTransparentSmall = {
	...zoneTransparent, fill: null, outlineWidth: 0
}

const roadBase = {
	outlineColor: "#333333",
	outlineWidth: 5,
	outlineOpacity: 1
};

const roadBaseSmall = {
	...roadBase, outlineWidth: 2
}


const interferometryBase = {
	fill: "#cccccc",
	fillOpacity: .7,
	outlineColor: "#555555",
	outlineWidth: 1,
	outlineOpacity: 1
};

const interferometryBaseSmall = {
	...interferometryBase,
	outlineOpacity: 0.6
};

const interferometryBaseAsPoints = {
	...interferometryBase,
	outlineWidth: 0,
};

/* === ATTRIBUTES === */

// Zones
const p75AttributeIntervalsZones = {
	attributeKey: "p75",
	attributeClasses: [
		{
			interval: [0, 10],
			fill: "#a1ff62"
		}, {
			interval: [10, 20],
			fill: "#f7ff03"
		}, {
			interval: [20, 30],
			fill: "#ffb300"
		}, {
			interval: [30, 40],
			fill: "#ff4a2a"
		}, {
			interval: [40, 50],
			fill: "#cc1b00"
		}, {
			interval: [50, 100],
			fill: "#990002"
		}
	]
};

const p75AttributeIntervalsZonesDts = {
	...p75AttributeIntervalsZones,
	attributeKey: "p75_dts"
};

const landslides = {
	attributeKey: "ls_freq",
	attributeValues: {
		0: {
			fill: "#828282"
		},
		1: {
			fill: "#fce96b"
		},
		2: {
			fill: "#f9d356"
		},
		3: {
			fill: "#f6bd42"
		},
		4: {
			fill: "#f2a72d"
		},
		5: {
			fill: "#dc9522"
		},
		6: {
			fill: "#c58216"
		},
		7: {
			fill: "#af700b"
		},
	}
};

const susceptibility  = {
	attributeKey: "susc_p83",
	attributeClasses: [
		{
			interval: [0, 0.2],
			fill: "#ffccff"
		}, {
			interval: [0.2, 0.4],
			fill: "#e899e7"
		}, {
			interval: [0.4, 0.6],
			fill: "#e675e5"
		}, {
			interval: [0.6, 0.8],
			fill: "#d646d4"
		}, {
			interval: [0.8, 1],
			fill: "#c700c7"
		}
	]
};

// Roads
const p75AttributeIntervalsRoads = {
	attributeKey: "p75_weight",
	attributeClasses: p75AttributeIntervalsZones.attributeClasses.map(cls => {return {...cls, outlineColor: cls.fill}})
}

// Points
const relCm = {
	attributeKey: "rel_cm",
	attributeValues: {
		"A": {
			size: 20
		},
		"B": {
			size: 14
		},
		"C": {
			size: 10
		},
		"D": {
			size: 6
		}
	}
};

const relCmAsPoints = {
	attributeKey: "rel_cm",
	attributeValues: {
		"A": {
			size: 20
		},
		"B": {
			size: 14
		},
		"C": {
			size: 10
		},
		"D": {
			size: 6
		}
	}
};

const relCmSmall = {
	attributeKey: "rel_cm",
	attributeValues: {
		"A": {
			size: 4
		},
		"B": {
			size: 3
		},
		"C": {
			size: 2
		},
		"D": {
			size: 1
		}
	}
};

const velAvg = {
	attributeKey: "vel_avg",
	attributeClasses: [
		{
			"fill": "#b1001d",
			"interval": [
				-1000,
				-50
			],
			"intervalBounds": [
				true,
				false
			]
		},
		{
			"fill": "#ca2d2f",
			"interval": [
				-50,
				-40
			],
			"intervalBounds": [
				true,
				false
			]
		},
		{
			"fill": "#e25b40",
			"interval": [
				-40,
				-30
			],
			"intervalBounds": [
				true,
				false
			]
		},
		{
			"fill": "#ffaa00",
			"interval": [
				-30,
				-20
			],
			"intervalBounds": [
				true,
				false
			]
		},
		{
			"fill": "#ffff00",
			"interval": [
				-20,
				-10
			],
			"intervalBounds": [
				true,
				false
			]
		},
		{
			"fill": "#a0f000",
			"interval": [
				-10,
				0
			],
			"intervalBounds": [
				true,
				false
			]
		},
		{
			"fill": "#4ce600",
			"interval": [
				0,
				10
			],
			"intervalBounds": [
				true,
				false
			]
		},
		{
			"fill": "#50d48e",
			"interval": [
				10,
				20
			],
			"intervalBounds": [
				true,
				false
			]
		},
		{
			"fill": "#00c3ff",
			"interval": [
				20,
				30
			],
			"intervalBounds": [
				true,
				false
			]
		},
		{
			"fill": "#0f80d1",
			"interval": [
				30,
				40
			],
			"intervalBounds": [
				true,
				false
			]
		},
		{
			"fill": "#004ca8",
			"interval": [
				40,
				50
			],
			"intervalBounds": [
				true,
				false
			]
		},
		{
			"fill": "#003e8a",
			"interval": [
				50,
				1000
			],
			"intervalBounds": [
				true,
				false
			]
		}
	]
};

export default {
	zoneBase,
	zoneBaseSmall,
	zoneTransparent,
	zoneTransparentSmall,

	roadBase,
	roadBaseSmall,

	interferometryBase,
	interferometryBaseSmall,
	interferometryBaseAsPoints,

	landslides,
	susceptibility,
	p75AttributeIntervalsZones,
	p75AttributeIntervalsZonesDts,
	p75AttributeIntervalsRoads,

	relCm,
	relCmAsPoints,
	relCmSmall,
	velAvg
}